// import React, { useState, useEffect } from "react";
// import PopupForm from "./PopupForm.js"; // Import the Popup Form
// import "./DigitalMarket.css";

// const services = [
//   {
//     title: "Boost Your Brand with Digital Marketing",
//     description:
//       "In today's digital age, having an online presence is crucial for business success. Our digital marketing solutions ensure that your brand reaches the right audience with maximum engagement.",
//   },
//   {
//     title: "SEO Optimization for Better Visibility",
//     description:
//       "Our SEO strategies help improve search engine rankings, driving organic traffic and increasing conversions. From keyword research to technical SEO, we optimize every aspect.",
//   },
//   {
//     title: "Social Media Marketing (SMM)",
//     description:
//       "Enhance brand engagement through targeted social media campaigns on platforms like Facebook, Instagram, LinkedIn, and Twitter. Connect with your audience effectively!",
//   },
//   {
//     title: "Pay-Per-Click (PPC) Advertising",
//     description:
//       "Get instant results with our PPC advertising strategies. We create data-driven ad campaigns to maximize ROI on platforms like Google Ads and Meta Ads.",
//   },
//   {
//     title: "Content Marketing for Authority",
//     description:
//       "Quality content drives trust and engagement. We craft compelling blogs, videos, and infographics that enhance your online authority and attract potential customers.",
//   },
//   {
//     title: "Email Marketing & Automation",
//     description:
//       "Convert leads into customers with personalized email marketing campaigns. Automate follow-ups and nurture customer relationships efficiently.",
//   },
//   {
//     title: "Analytics & Performance Tracking",
//     description:
//       "Measure your marketing success with our analytics tools. We provide detailed reports to track performance and refine strategies for better results.",
//   },
//   {
//     title: "Who Can Benefit from Digital Marketing?",
//     description:
//       "Our digital marketing solutions benefit:\n- Startups & Small Businesses\n- E-commerce Stores\n- Corporates & Enterprises\n- Personal Brands & Influencers\n- Agencies & More.",
//   },
// ];

// const DigitalMarket = () => {
//   const [isPopupOpen, setIsPopupOpen] = useState(false);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isHovered, setIsHovered] = useState(false); // Track hover state

//   // Function to open the PDF in a new tab
//   const openPDF = () => {
//     window.open("./Digital_Marketing_Services.pdf");
//   };

//   // Function to go to the next service
//   const nextService = () => {
//     setCurrentIndex((prevIndex) => (prevIndex + 1) % services.length);
//   };

//   // Function to go to the previous service
//   const prevService = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex === 0 ? services.length - 1 : prevIndex - 1
//     );
//   };

//   // Auto-change services every 5 seconds, but stop when hovered
//   useEffect(() => {
//     if (!isHovered) {
//       const interval = setInterval(() => {
//         nextService();
//       }, 5000);
//       return () => clearInterval(interval);
//     }
//   }, [isHovered]); // Re-run when hover state changes

//   return (
//     <div className="digital-market-container">
//       {/* Hero Section */}
//       <section className="hero-digital-section">
//         <div className="hero-content">
//           <h1>Digital Marketing Services</h1>
//           <p>
//             Expand your brand's digital presence with data-driven marketing strategies.
//           </p>
//           <div className="hero-buttons-wrapper">
//             <button className="connect-now-btn" onClick={() => setIsPopupOpen(true)}>
//               Connect Now!
//             </button>
//             <button className="open-pdf-btn" onClick={openPDF}>
//               View PDF
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* About Digital Marketing */}
//       <section className="about-dm-section">
//         <div className="about-content">
//           <div className="vector-image">
//             <img src="./dm-img.png" alt="Digital Marketing Vector" />
//           </div>

//           <div className="about-text">
//             <h2>What is Digital Marketing?</h2>
//             <p>
//               Digital marketing helps businesses establish an online presence, attract potential customers, and increase revenue through various online strategies.
//             </p>
//             <ul>
//               <li>🔹 SEO & Website Optimization</li>
//               <li>🔹 Social Media Marketing</li>
//               <li>🔹 PPC & Google Ads</li>
//               <li>🔹 Email & Content Marketing</li>
//             </ul>
//           </div>
//         </div>
//       </section>

//       {/* Features */}
//       <section className="features-section">
//         <h2 className="section-title">Why Choose Our Digital Marketing Services?</h2>
//         <div className="features-grid">
//           <div className="feature-card">
//             <span className="feature-icon">🚀</span>
//             <h3>Increased Brand Awareness</h3>
//             <p>Reach a wider audience through optimized campaigns.</p>
//           </div>
//           <div className="feature-card">
//             <span className="feature-icon">📊</span>
//             <h3>Data-Driven Strategies</h3>
//             <p>Utilize analytics to improve marketing efficiency.</p>
//           </div>
//           <div className="feature-card">
//             <span className="feature-icon">💰</span>
//             <h3>High ROI Marketing</h3>
//             <p>Maximize profits with cost-effective advertising.</p>
//           </div>
//         </div>
//       </section>

//       {/* Carousel Section */}
//       <section className="dm-bottom-section">
//         <h2>Upgrade Your Digital Marketing Strategy Today</h2>
//         <div
//           className="service-carousel"
//           onMouseEnter={() => setIsHovered(true)} // Stop auto-scroll when hovered
//           onMouseLeave={() => setIsHovered(false)} // Resume auto-scroll when unhovered
//         >
//           <div className="service-card">
//             <h3>{services[currentIndex].title}</h3>
//             <p>{services[currentIndex].description}</p>
//             <div className="carousel-controls">
//               <button onClick={prevService}>&#9665;</button> {/* Left arrow */}
//               <button onClick={nextService}>&#9655;</button> {/* Right arrow */}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Popup Form Component */}
//       <PopupForm isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
//     </div>
//   );
// };

// export default DigitalMarket;


import React, { useState, useEffect } from "react";
import PopupForm from "./PopupForm.js"; // Import the Popup Form
import "./DigitalMarket.css";

const services = [
  {
    title: "Affiliate Marketing - Performance-Based Growth",
    description:
      "Leverage the power of affiliate marketing to drive sales and brand awareness. Our strategy focuses on partnerships, commission-based promotions, and high-converting traffic sources.",
  },
  {
    title: "SEO Optimization - Enhance Search Visibility",
    description:
      "Boost your brand’s online presence with advanced SEO techniques, including keyword research, on-page optimization, and technical improvements.",
  },
  {
    title: "Social Media Marketing (SMM) - Maximize Engagement",
    description:
      "Utilize targeted social media campaigns on platforms like Facebook, Instagram, and LinkedIn to enhance customer interaction and brand recognition.",
  },
  {
    title: "Pay-Per-Click (PPC) Advertising - Generate Instant Leads",
    description:
      "Launch data-driven PPC campaigns using Google Ads and Meta Ads to achieve high ROI and convert targeted leads into customers.",
  },
  {
    title: "Content Marketing - Drive Authority and Trust",
    description:
      "Create compelling blog posts, videos, and infographics to establish industry authority and engage potential customers effectively.",
  },
  {
    title: "Email Marketing - Automate Customer Outreach",
    description:
      "Develop personalized email campaigns that nurture leads, build loyalty, and drive consistent engagement with your audience.",
  },
  {
    title: "Who Can Benefit from Digital Marketing?",
    description:
      "Our digital marketing services cater to:\n- BFSI (Banking, Financial Services, Insurance)\n- E-commerce & Retail\n- Corporate Enterprises\n- Small Businesses & Startups\n- Influencers & Personal Brands.",
  },
];

const DigitalMarket = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false); // Track hover state

  // Function to open the PDF in a new tab
  const openPDF = () => {
    window.open("./Digital-Marketing.pdf");
  };

  // Function to go to the next service
  const nextService = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % services.length);
  };

  // Function to go to the previous service
  const prevService = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? services.length - 1 : prevIndex - 1
    );
  };

  // Auto-change services every 5 seconds, but stop when hovered
  useEffect(() => {
    if (!isHovered) {
      const interval = setInterval(() => {
        nextService();
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [isHovered]); // Re-run when hover state changes

  return (
    <div className="digital-market-container">
      {/* Hero Section */}
      <section className="hero-digital-section">
        <div className="hero-content">
          <h1>Digital Marketing Services</h1>
          <p>
            Transform your digital presence with innovative marketing strategies tailored for BFSI and other industries.
          </p>
          <div className="hero-buttons-wrapper">
            <button className="connect-now-btn" onClick={() => setIsPopupOpen(true)}>
              Connect Now!
            </button>
            <button className="open-pdf-btn" onClick={openPDF}>
              View PDF
            </button>
          </div>
        </div>
      </section>

      {/* About Digital Marketing */}
      <section className="about-dm-section">
        <div className="about-content">
          <div className="vector-image">
            <img src="./dm.png" alt="Digital Marketing Vector" />
          </div>

          <div className="about-text">
            <h2>What is Digital Marketing?</h2>
            <p>
              Digital marketing is essential for businesses aiming to grow in a competitive landscape. Our strategies include Affiliate Marketing, SEO, PPC, and more to ensure maximum reach and impact.
            </p>
            <ul>
              <li>🔹 Affiliate Marketing & Performance-Based Growth</li>
              <li>🔹 SEO & PPC for High-Quality Lead Generation</li>
              <li>🔹 Social Media & Content Marketing for Brand Awareness</li>
              <li>🔹 Email & Automation for Customer Retention</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="features-section">
        <h2 className="section-title">Why Choose Our Digital Marketing Services?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">📈</span>
            <h3>Affiliate Marketing</h3>
            <p>Grow your business with performance-based partnerships.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🔍</span>
            <h3>SEO & PPC</h3>
            <p>Improve search rankings and generate leads efficiently.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">📩</span>
            <h3>Email & Automation</h3>
            <p>Engage and retain customers with automated campaigns.</p>
          </div>
        </div>
      </section>

      {/* Carousel Section */}
      <section className="dm-bottom-section">
        <h2>Leverage Digital Marketing for Success</h2>
        <div
          className="service-carousel"
          onMouseEnter={() => setIsHovered(true)} // Stop auto-scroll when hovered
          onMouseLeave={() => setIsHovered(false)} // Resume auto-scroll when unhovered
        >
          <div className="service-card">
            <h3>{services[currentIndex].title}</h3>
            <p>{services[currentIndex].description}</p>
            <div className="carousel-controls">
              <button onClick={prevService}>&#9665;</button> {/* Left arrow */}
              <button onClick={nextService}>&#9655;</button> {/* Right arrow */}
            </div>
          </div>
        </div>
      </section>

      {/* Popup Form Component */}
      <PopupForm isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  );
};

export default DigitalMarket;
